
<main-form-modal (toggleChange)="setVal($event)"> 
    <ng-template #customHtmlElements>
        <div [ngSwitch]="editMode">
            <campaign-edit *ngSwitchCase="true"></campaign-edit>
            <campaign-details *ngSwitchCase="false"></campaign-details>
        </div>
    </ng-template>  
</main-form-modal>